import React, { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { connect } from "react-redux";
import { userActions } from "../_actions/user.actions.js";
import MainContainer from "../Components/MainContainer.js";
import "../style/Home.css";
import "../style/ReportCard.css";
import "../style/Bundles.css";
import { Accordion, Card, Col, Form } from "react-bootstrap";
import {
  getUserLicenseBundleList,
  addUserToDb,
  getBusinessUnits,
  getLicenseBundles,
  getUsersWithAccessToSupportCenter,
} from "../Services/ReportingService.js";
import QuickAddUserModal from "../Components/QuickAddUserModal.js";
import PuffLoader from "react-spinners/PuffLoader";
import { Tooltip } from "react-tooltip";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import BundlesList from "../Components/BundlesList.js";
import Notification from "../Components/Notification.js";
import { NotificationsContext } from "../Contexts/NotificationsContext";
import RowCard from "../Components/RowCard.js";

const Bundles = (props) => {
  const [loading, setLoading] = useState(true);
  const [displayAddUserModal, setDisplayAddUserModal] = useState(false);
  const [adminAccess, setAdminAccess] = useState(false);
  const [businessUnitList, setBusinessUnitList] = useState([]);
  const [businessUnitsForNotHomeOfficeUsers, setBusinessUnitsForNotHomeOfficeUsers] = useState([]);
  const [userBundleLicensesByCompanyLists, setUserBundleLicensesByCompanyLists] = useState([]);
  const [licenseBundles, setLicenseBundles] = useState([]);
  const [asanaEmpBundleId, setAsanaEmpBundleId] = useState("");
  const [cityViewBundleId, setCityViewBundleId] = useState("");
  const [asanaOwnerBundleId, setAsanaOwnerBundleId] = useState("");
  const [asanaEmpBundlePrice, setAsanaEmpBundlePrice] = useState(0);
  const { addNotification } = useContext(NotificationsContext);
  const [companyToBusinessUnitMap, setCompanyToBusinessUnitMap] = useState(new Map());
  const [allBusinessUnits, setAllBusinessUnits] = useState();
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState();
  const [totalNumberOfBusinessUnits, setTotalNumberOfBusinessUnits] = useState(0);
  const [isShowingAllBusinessUnits, setIsShowingAllBusinessUnits] = useState(false);
  const [bundleTotals, setBundleTotals] = useState({});
  const [defaultOpenAccordionKey, setDefaultOpenAccordionKey] = useState("000");
  const [isHomeOffice, setIsHomeOffice] = useState(false);
  const pilotGroupBusinessUnits = useMemo(
    () =>
      new Set([
        "CWM Home Office",
        "National Business Development",
        "KC - Window Washing",
        "Kansas City",
        "Boston",
        "Las Vegas",
        "Oklahoma",
        "Omaha NE",
        "San Diego",
        "Tampa Bay",
        "Tulsa",
        "Wichita",
        "Springfield",
        "Northern Nevada",
        "South Dakota",
        "Orange County North",
        "Edmonton",
      ]),
    [],
  );

  const businessUnit = JSON.parse(sessionStorage.getItem("businessUnit"));
  const userId = sessionStorage.getItem("userId");
  const turnOnCityView = false;

  const getAllBusinessUnits = useCallback(async () => {
    const username = sessionStorage.getItem("username");
    const isHomeOffice =
      businessUnit.businessUnitName === "CWM Home Office" ||
      businessUnit.businessUnitName === "City Wide Maintenance (root)";
    setIsHomeOffice(isHomeOffice);
    setAdminAccess(isHomeOffice);

    await getBusinessUnits().then(async (response) => {
      if (response) {
        const filteredResponseBUs = response.filter((bu) => pilotGroupBusinessUnits.has(bu.businessUnitName));
        const newCompanyToBusinessUnitMap = new Map();
        const responseBUs = filteredResponseBUs;
        await getUsersWithAccessToSupportCenter().then((response) => {
          const usersThatHaveAccessToSupportCenter = new Set([]);
          response.forEach((user) => {
            usersThatHaveAccessToSupportCenter.add(user.email);
          });

          if (isHomeOffice || usersThatHaveAccessToSupportCenter.has(username)) {
            responseBUs.push({
              businessUnitGuid: null,
              businessUnitName: "Support Center",
              bcCompanyName: "Support Center",
              companyNumber: "Support Center",
              usingBc: null,
            });
          }
        });
        setBusinessUnitList(responseBUs);
        setAllBusinessUnits(responseBUs);
        setTotalNumberOfBusinessUnits(responseBUs.length);
        responseBUs.push({
          businessUnitGuid: null,
          businessUnitName: "Staffing Solutions",
          bcCompanyName: "Staffing Solutions",
          companyNumber: "Staffing Solutions",
          usingBc: null,
        });
        responseBUs.forEach((bu) => {
          newCompanyToBusinessUnitMap.set(bu.bcCompanyName, bu.businessUnitName);
        });
        setCompanyToBusinessUnitMap(newCompanyToBusinessUnitMap);
      }
    });
    setLoading(false);
  }, [businessUnit.businessUnitName, pilotGroupBusinessUnits]);

  const getBusinessUnitsForNotHomeOfficeUsers = useCallback(() => {
    const newBusinessUnitsForNotHomeOfficeUsers = new Set();
    userBundleLicensesByCompanyLists[0].forEach((user) => {
      if (!newBusinessUnitsForNotHomeOfficeUsers.has(companyToBusinessUnitMap.get(user.companyName))) {
        newBusinessUnitsForNotHomeOfficeUsers.add(companyToBusinessUnitMap.get(user.companyName));
      }
    });
    const businessUnits = Array.from(newBusinessUnitsForNotHomeOfficeUsers).sort();
    setBusinessUnitsForNotHomeOfficeUsers(businessUnits);
    setAllBusinessUnits(businessUnits);
    setTotalNumberOfBusinessUnits(newBusinessUnitsForNotHomeOfficeUsers.size);
  }, [companyToBusinessUnitMap, userBundleLicensesByCompanyLists]);

  const getTotalItaasBundlesTotalPriceForBuNonHomeOffice = useCallback(
    (users) => {
      let standardItaasBundle = licenseBundles.find(
        (license) => license.iTaaS === true && license.bundleName === "Standard",
      );
      let premiumItaasBundle = licenseBundles.find(
        (license) => license.iTaaS === true && license.bundleName === "Premium",
      );
      let itaasBundlesTotalPrice = 0;

      itaasBundlesTotalPrice +=
        users.filter((user) => user.itaasPackageId === standardItaasBundle.bundleId).length *
        standardItaasBundle.bundlePrice;
      itaasBundlesTotalPrice +=
        users.filter((user) => user.itaasPackageId === premiumItaasBundle.bundleId).length *
        premiumItaasBundle.bundlePrice;

      return itaasBundlesTotalPrice;
    },
    [licenseBundles],
  );

  const getTotalBundlePriceForNonHomeOffice = useCallback(
    (users) => {
      let totalPrice = 0;
      licenseBundles.forEach((bundle) => {
        if (bundle.iTaaS === false) {
          totalPrice += users.filter((user) => user.licenseBundleId === bundle.bundleId).length * bundle.bundlePrice;
        }
      });
      return totalPrice;
    },
    [licenseBundles],
  );

  useEffect(() => {
    getUserLicenseBundleList(userId).then((response) => {
      setUserBundleLicensesByCompanyLists(
        response.filter((bundle) => bundle.bundleName !== "Basic Systems Bundle Only"),
      );
    });

    getAllBusinessUnits();

    getLicenseBundles().then((response) => {
      if (response) {
        setLicenseBundles(response);

        setCityViewBundleId(response.find((bundle) => bundle.bundleName === "City View").bundleId);
        setAsanaEmpBundleId(response.find((bundle) => bundle.bundleName === "Asana - Employee").bundleId);
        setAsanaOwnerBundleId(response.find((bundle) => bundle.bundleName === "Asana - Owner").bundleId);
        setAsanaEmpBundlePrice(response.find((bundle) => bundle.bundleName === "Asana - Employee").bundlePrice);
      }
    });
  }, [userId, getAllBusinessUnits]);

  const getTotalNumberOfItaasUserForBuNonHomeOffice = useCallback(
    (users) => {
      let standardItaasBundleGuid = licenseBundles.find(
        (license) => license.iTaaS === true && license.bundleName === "Standard",
      ).bundleId;
      let premiumItaasBundleGuid = licenseBundles.find(
        (license) => license.iTaaS === true && license.bundleName === "Premium",
      ).bundleId;

      return users.filter(
        (user) => user.itaasPackageId === standardItaasBundleGuid || user.itaasPackageId === premiumItaasBundleGuid,
      ).length;
    },
    [licenseBundles],
  );

  useEffect(() => {
    if (userBundleLicensesByCompanyLists.length > 0 && companyToBusinessUnitMap.size > 0 && !isHomeOffice) {
      getBusinessUnitsForNotHomeOfficeUsers();
    }
  }, [userBundleLicensesByCompanyLists, companyToBusinessUnitMap, getBusinessUnitsForNotHomeOfficeUsers, isHomeOffice]);

  useEffect(() => {
    if (totalNumberOfBusinessUnits > 0) {
      if (isHomeOffice && totalNumberOfBusinessUnits > 5) {
        setBusinessUnitList([allBusinessUnits[0]]);
      } else if (!isHomeOffice && totalNumberOfBusinessUnits > 5) {
        setBusinessUnitsForNotHomeOfficeUsers([allBusinessUnits[0]]);
      }
      setSelectedBusinessUnit(allBusinessUnits[0]);
      setDefaultOpenAccordionKey(isHomeOffice ? allBusinessUnits[0].CompanyNumber : allBusinessUnits[0].businessUnit);
    }
  }, [totalNumberOfBusinessUnits, allBusinessUnits, isHomeOffice]);

  useEffect(() => {
    if (
      licenseBundles.length > 0 &&
      userBundleLicensesByCompanyLists[0] &&
      userBundleLicensesByCompanyLists[0].length > 0
    ) {
      setBundleTotals({
        bundlesPrice: getTotalBundlePriceForNonHomeOffice(userBundleLicensesByCompanyLists[0]).toLocaleString(),
        itaasBundlesPrice: getTotalItaasBundlesTotalPriceForBuNonHomeOffice(
          userBundleLicensesByCompanyLists[0],
        ).toLocaleString(),
        numberOfItaasUsers: getTotalNumberOfItaasUserForBuNonHomeOffice(
          userBundleLicensesByCompanyLists[0],
        ).toLocaleString(),
        numberOfUsers: userBundleLicensesByCompanyLists[0].length.toLocaleString(),
      });
    }
  }, [
    licenseBundles,
    userBundleLicensesByCompanyLists,
    getTotalBundlePriceForNonHomeOffice,
    getTotalItaasBundlesTotalPriceForBuNonHomeOffice,
    getTotalNumberOfItaasUserForBuNonHomeOffice,
  ]);

  const addUser = async (user) => {
    let newUser = {};
    newUser.CompanyName = user.companyName;
    newUser.DomainName = user.domainName;
    newUser.FullName = user.fullName;
    newUser.LicenseBundleId = licenseBundles.find((x) => x.bundleName === user.licenseBundleName).bundleId;
    newUser.ItaasPackageId = licenseBundles.find((x) => x.bundleName === user.itaasLevel).bundleId;
    newUser.CityViewPackageId = "00000000-0000-0000-0000-000000000000";

    if (user.asanaPackageShortName === "None") {
      newUser.AsanaPackageId = "00000000-0000-0000-0000-000000000000";
    } else if (user.asanaPackageShortName.includes("Employee")) {
      newUser.AsanaPackageId = licenseBundles.find((x) => x.bundleName === "Asana - Employee").bundleId;
    } else if (user.asanaPackageShortName.includes("Owner")) {
      newUser.AsanaPackageId = licenseBundles.find((x) => x.bundleName === "Asana - Owner").bundleId;
    }

    try {
      await addUserToDb(newUser);
      addNotification({ show: true, type: "Success", description: "User Added Successfully" });
    } catch (error) {
      console.error(error);
      addNotification({
        show: true,
        type: "Error",
        description: (
          <>
            Adding User Failed. Please contact
            <b>itsupport@gocitywide.com</b> for assistance.
          </>
        ),
      });
    }

    setDisplayAddUserModal(false);
  };

  const toggleShowAllBusinessUnits = () => {
    const newIsShowingAllBusinessUnits = !isShowingAllBusinessUnits;
    if (isHomeOffice) {
      if (newIsShowingAllBusinessUnits) {
        setBusinessUnitList(allBusinessUnits);
      } else {
        setBusinessUnitList([selectedBusinessUnit]);
      }
    } else {
      if (newIsShowingAllBusinessUnits) {
        setBusinessUnitsForNotHomeOfficeUsers(allBusinessUnits);
      } else {
        setBusinessUnitsForNotHomeOfficeUsers([selectedBusinessUnit]);
      }
    }
    setIsShowingAllBusinessUnits(newIsShowingAllBusinessUnits);
  };

  const handleSelectBusinessUnitChange = (e) => {
    let selectedBusinessUnit;
    if (isHomeOffice) {
      selectedBusinessUnit = allBusinessUnits.find((bu) => bu.businessUnitName === e.target.value);
      setBusinessUnitList([selectedBusinessUnit]);
    } else {
      selectedBusinessUnit = allBusinessUnits.find((bu) => bu === e.target.value);
      setBusinessUnitsForNotHomeOfficeUsers([selectedBusinessUnit]);
    }
    setSelectedBusinessUnit(selectedBusinessUnit);
  };

  return (
    <MainContainer>
      <Notification />
      {adminAccess && (
        <div className="d-flex flex-row justify-content-between pb-2">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <strong className="page-title" data-testid="bundle-heading">
                Bundles
              </strong>
              <InfoOutlinedIcon
                id="bundleHeaderTooltip"
                sx={{ verticalAlign: "top", margin: "8px", color: "#2d2926" }}
              />
            </div>
            {totalNumberOfBusinessUnits > 5 && (
              <Form.Group style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                {!isShowingAllBusinessUnits && (
                  <Col>
                    <Form.Select
                      as="select"
                      value={
                        isHomeOffice && selectedBusinessUnit
                          ? selectedBusinessUnit.businessUnitName
                          : selectedBusinessUnit
                      }
                      onChange={(e) => handleSelectBusinessUnitChange(e)}
                    >
                      {allBusinessUnits.map((bu) => {
                        return (
                          <option value={isHomeOffice ? bu.businessUnitName : bu}>
                            {isHomeOffice ? bu.businessUnitName : bu}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Col>
                )}
                <Col style={{ marginLeft: "20px" }}>
                  <input
                    type="checkbox"
                    onClick={() => toggleShowAllBusinessUnits()}
                    checked={isShowingAllBusinessUnits}
                    className="showAllBUsCheckbox"
                    id={"showAllBusinessUnits"}
                  />
                  <label for="showAllBusinessUnits" style={{ color: "white" }}>
                    Show All Business Units
                  </label>
                </Col>
              </Form.Group>
            )}
          </div>
          <div className="addUserButton">
            <button
              type="button"
              onClick={() => setDisplayAddUserModal(true)}
              className={`btn btn-dark mx-lg-auto float-right float-lg-none w-100`}
            >
              <FontAwesomeIcon icon={faCheck} /> Add User
            </button>
          </div>
        </div>
      )}
      <Accordion defaultActiveKey={defaultOpenAccordionKey}>
        {!loading && (
          <>
            <RowCard
              data={[
                <span>
                  Total Users:<span style={{ marginLeft: 8 }}>{bundleTotals.numberOfUsers}</span>
                </span>,
                <span>
                  Total Price:<span style={{ marginLeft: 8 }}>${bundleTotals.bundlesPrice}</span>
                </span>,
                <span>
                  Total ITaaS Users:
                  <span style={{ marginLeft: 8 }}>${bundleTotals.numberOfItaasUsers}</span>
                </span>,
                <span>
                  Total ITaaS Price:
                  <span style={{ marginLeft: 8 }}>${bundleTotals.itaasBundlesPrice}</span>
                </span>,
              ]}
              mode="centered"
              padding="20px"
            />
            <Card className="header-card pt-2 pb-2">
              {businessUnit && isHomeOffice && licenseBundles && (
                <>
                  {businessUnitList.map((list) => {
                    return (
                      <BundlesList
                        props={{
                          list,
                          userBundleLicensesByCompanyLists,
                          licenseBundles,
                          isHomeOffice,
                          adminAccess,
                          turnOnCityView,
                          cityViewBundleId,
                          asanaEmpBundlePrice,
                          asanaEmpBundleId, //Only needed if isHomeOffice is true
                          asanaOwnerBundleId, //Only needed if isHomeOffice is true
                          companyToBusinessUnitMap,
                        }}
                      />
                    );
                  })}
                </>
              )}
              {businessUnit && !isHomeOffice && licenseBundles && (
                <>
                  {businessUnitsForNotHomeOfficeUsers.map((businessUnit, index) => {
                    return (
                      <BundlesList
                        props={{
                          isHomeOffice,
                          businessUnit,
                          userBundleLicensesByCompanyLists,
                          licenseBundles,
                          adminAccess,
                          turnOnCityView,
                          cityViewBundleId,
                          companyToBusinessUnitMap,
                          isLastList: index === businessUnitsForNotHomeOfficeUsers.length - 1,
                        }}
                      />
                    );
                  })}
                </>
              )}
            </Card>
          </>
        )}
        <div className={`d-flex ${loading ? "" : "d-none"}`}>
          <div className="d-flex flex-row">
            <strong className="page-title" data-testid="bundle-heading">
              Bundles
            </strong>
          </div>
        </div>
        <div className={`d-flex ${loading ? "" : "d-none"}`}>
          <div className={`mx-auto d-flex`}>
            <PuffLoader size={150} color={"#FFFFFF"} loading={loading} />
          </div>
        </div>
      </Accordion>
      <QuickAddUserModal
        show={displayAddUserModal}
        onHide={() => setDisplayAddUserModal(false)}
        onCancel={() => setDisplayAddUserModal(false)}
        onAdd={(user) => {
          addUser(user);
        }}
        businessUnits={allBusinessUnits}
        bundles={licenseBundles}
        licenseBundles={licenseBundles}
      />
      <Tooltip id="itaasToolTip" anchorSelect="#opsBuildingCountToolTipButton">
        <div>
          <div className="tooltip-heading">
            <p>IT as a Service (ITaaS)</p>
          </div>
          <div className="tooltip-body">
            <p>
              City Wide IT as a Service enables your franchise to utilize the Support Center for your Office 365
              subscriptions and other IT support needs.
            </p>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">None: </p>
              Regular support level and licensing for CWCMS systems.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Standard: </p>
              Includes Office 365 subscription on the GoCityWide domain.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Premium: </p>
              Includes Office 365 subscription plus complete IT support needs for your office.
            </li>
            <p className="tooltip-footer">Contact ITSupport@GoCityWide.com for more information.</p>
          </div>
        </div>
      </Tooltip>
      <Tooltip id="bundleHeaderTooltip" anchorSelect="#bundleHeaderTooltip">
        <div>
          <div className="tooltip-body">
            <p>
              Choose the most appropriate license bundle, based on the user's role. See below for the available license
              bundles.
            </p>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Accounting: </p>
              Controllers, accounting staff, and anyone who enters data into BC.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Operations: </p>
              FSM, DOO, and ops users other than Night Managers.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Sales: </p>
              Sales Executives and sales management, BDS, and Sales Associates.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Executive: </p>
              Franchise owners and general managers who are not performing accounting, ops, or sales roles (if the owner
              or GM is acting as an accounting, ops, or sales role, then select the most appropriate bundle for the role
              the user is performing).
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Email Only: </p>
              Users or Distribution Lists (DL) that have email but no need for any other system access.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Night Manager: </p>
              As you might guess, this is good for Night Managers.
            </li>
            <li className="tooltip-listItem">
              <p className="tooltip-subheader">Administrative User: </p>
              CRM but not BC users. This might be an IC recruiter or other person requiring CRM access who is not an
              accounting user.
            </li>
          </div>
        </div>
      </Tooltip>
    </MainContainer>
  );
};

function mapStateToProps(state) {
  const { authentication } = state;
  const { crmUser } = authentication;
  return { crmUser };
}

const actionCreators = {
  logout: userActions.logout,
  changePage: userActions.changePage,
};

const connectedBundlesPage = connect(mapStateToProps, actionCreators)(Bundles);
export { connectedBundlesPage as Bundles };
